import type { ConciseWorkspace } from '@festina/configuration-general-types/configuration'
import { assertNotEmpty, type ConfigurableServer } from '@festina-life/core'
import { IconButton } from '@festina-life/ui/actions'
import { useTranslate } from '@festina-life/ui/hooks'

import { isEqualWorkspace } from '../../../../workspace/helpers'
import { useWorkspaceManagerContext } from '../../../../workspace/workspaceManagerContext'
import { DeleteWorkspaceButton } from '../../../deleteWorkspaceButton/DeleteWorkspaceButton'
import { WorkspaceName } from '../../../workspaceName/WorkspaceName'
import { conciseWorkspaceToWorkspaceKey } from './helpers'
import { useOpenWorkspace } from './useOpenWorkspace'

type Props = {
  conciseWorkspace: ConciseWorkspace
  server: ConfigurableServer
}

export const BranchWorkspaceEntry = ({ conciseWorkspace, server }: Props) => {
  const translate = useTranslate()
  const { onSwitch, currentWorkspaceKey } = useWorkspaceManagerContext()
  const workspaceKey = conciseWorkspaceToWorkspaceKey({
    workspace: conciseWorkspace,
    server,
  })
  const { mutateAsync, isLoading } = useOpenWorkspace(workspaceKey)

  const handleCloseWorkspace = () => {
    void onSwitch(null)
  }

  assertNotEmpty(conciseWorkspace.name)

  const isCurrentWorkspace = isEqualWorkspace(workspaceKey, currentWorkspaceKey)

  return (
    <div className="group flex w-full items-center justify-between flex-row gap-x-2 hover:bg-slate-100 dark:hover:bg-slate-700 rounded-md p-1">
      <WorkspaceName isShowingIcon={false} workspaceKey={workspaceKey} />

      <div className="flex gap-x-1">
        <IconButton
          iconName={isCurrentWorkspace ? 'XCircle' : 'ArrowRightEndOnRectangle'}
          className="invisible group-hover:visible p-0!"
          onClick={isCurrentWorkspace ? handleCloseWorkspace : mutateAsync}
          tip={
            isCurrentWorkspace
              ? translate('workspace.close')
              : translate('workspace.open')
          }
          isLoading={isLoading}
        />

        <DeleteWorkspaceButton variant="icon" workspaceKey={workspaceKey} />
      </div>
    </div>
  )
}
